import React from 'react';
import styles from './Footer.module.css';
import { PhoneTelephone, EmailDown, Phone, ScanCode, LinkOne } from '@icon-park/react';

function Footer() {
  const officialSite = 'https://www.huapubio.com.cn';
  
  const footerLinks = {
    '关于我们': [
      { name: '公司简介', url: `${officialSite}/about` },
      { name: '发展历程', url: `${officialSite}/history` },
      { name: '企业文化', url: `${officialSite}/culture` },
      { name: '联系我们', url: `${officialSite}/contact` }
    ],
    '产品服务': [
      { name: '数字标签生成', url: '#' },
      { name: '智能识别', url: '#' },
      { name: '标签管理', url: '#' },
      { name: 'API接口', url: '#' }
    ],
    '帮助中心': [
      { name: '使用指南', url: '#' },
      { name: '常见问题', url: '#' },
      { name: '视频教程', url: '#' },
      { name: '技术支持', url: '#' }
    ],
    '法律声明': [
      { name: '服务条款', url: '#' },
      { name: '隐私政策', url: '#' },
      { name: '版权声明', url: '#' },
      { name: '免责声明', url: '#' }
    ]
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerGrid}>
          <div className={styles.footerAbout}>
            <a
              className={styles.footerLogo}
              href="#"
              aria-label="访问数字标签内测官网"
            >
              <span className={styles.footerLogoText}>
                <strong>数字标签内测</strong>
                <small>Digital Label Beta</small>
              </span>
            </a>
            <p className={styles.footerDescription}>
              创新数字标签技术，引领食品行业未来。<br />
              为食品企业提供专业的数字标签生成与管理服务。
            </p>
            <div className={styles.footerContact}>
              <p>
                <PhoneTelephone theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                咨询热线: <a href="tel:029-81330339">029-81330339</a>
              </p>
              <p>
                <EmailDown theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                邮箱: <a href="mailto:service@huapubio.net">service@huapubio.net</a>
              </p>
              <p>
                <LinkOne theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                官网: <a href={officialSite} target="_blank" rel="noopener noreferrer">www.huapubio.com.cn</a>
              </p>
            </div>
          </div>
          
          {Object.entries(footerLinks).map(([title, links], index) => (
            <div key={index} className={styles.footerColumn}>
              <h4 className={styles.footerColumnTitle}>{title}</h4>
              <ul className={styles.footerLinks}>
                {links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.url} 
                      target={link.url.startsWith('http') ? '_blank' : '_self'}
                      rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className={styles.footerBottom}>
          <div className={styles.footerQrCodes}>
            <div className={styles.qrCodeItem}>
              <div className={styles.qrPlaceholder}>
                <ScanCode theme="outline" size={28} fill="#fff" strokeWidth={3} />
              </div>
              <span>微信公众号</span>
            </div>
            <div className={styles.qrCodeItem}>
              <div className={styles.qrPlaceholder}>
                <Phone theme="outline" size={28} fill="#fff" strokeWidth={3} />
              </div>
              <span>APP下载</span>
            </div>
          </div>
          <div className={styles.footerCopyright}>
            <p>© 2025 数字标签内测 All Rights Reserved.</p>
            <a
              className={styles.footerIcp}
              href="https://beian.miit.gov.cn"
              target="_blank"
              rel="noopener"
            >
              陕ICP备2024042935号
            </a>

          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
